import { createContext } from 'react';
import { AlertStore } from '../store/AlertStore';

export const AlertContext = createContext<AlertStore>({} as any);
